import cloneDeep from "lodash";

const initialState = {
  unreadNotifications: [],
  call: null
}


export default {
  namespaced: true,
  state: initialState,
  getters: {
    unreadNotifications: (state) => state.unreadNotifications,
    peerCall: (state) => state.call,
  },
  mutations: {
    SET_NOTIFICATIONS(state, notifications) {
      if (Array.isArray(notifications)) {
        state.unreadNotifications = notifications
      }
    },
    ADD_NOTIFICATIONS(state, notifications) {
      if (Array.isArray(notifications)) {
        state.unreadNotifications = [...notifications, ...cloneDeep(state.unreadNotifications)]
      }
    },
    MARK_AS_READ(state, id) {
      state.unreadNotifications = state.unreadNotifications.filter(notification => notification._id !== id)
    }
  },
  actions: {}
}
